/**
 * Minispiel-Konstanten (Single Source of Truth)
 *
 * Diese Datei definiert alle Konstanten für das Minispiel-System.
 *
 * Verwendung:
 * - Server: const { MINIGAME_MODE, SYNC_TYPE } = require('../../src/shared/core/minigameConstants');
 * - Client: import { MINIGAME_MODE, SYNC_TYPE } from './shared/core/minigameConstants';
 */

// =============================================================================
// MINIGAME MODI
// =============================================================================

/**
 * Grundmodus: Wie spielen die Spieler das Minispiel?
 */
const MINIGAME_MODE = {
  SIMULTANEOUS: 'simultaneous',  // Alle spielen gleichzeitig
  SEQUENTIAL: 'sequential',      // Nacheinander (andere schauen zu)
};

/**
 * Sync-Typ für gleichzeitige Spiele (nur relevant wenn mode=SIMULTANEOUS)
 */
const SYNC_TYPE = {
  ISOLATED: 'isolated',          // Jeder hat eigene Instanz (z.B. Reaktionstest)
  SHARED_VIEW: 'sharedView',     // Gemeinsamer Bildschirm, keine Interaktion
  INTERACTIVE: 'interactive',    // Gemeinsamer Bildschirm mit Interaktion
};

// =============================================================================
// MINIGAME TRIGGER
// =============================================================================

/**
 * Wie kann ein Minispiel getriggert werden?
 */
const MINIGAME_TRIGGER = {
  JOKER: 'joker',               // Durch Joker-Effekt
  SEAL: 'seal',                 // Durch Siegel-Effekt
  SPECIAL_CARD: 'specialCard',  // Durch Spezialkarte im Deck
  MAGIC_CARD: 'magicCard',      // Durch Zauberkarte beim Ziehen
  MANUAL: 'manual',             // Manuell (z.B. DevPanel)
};

// =============================================================================
// MINIGAME STATUS
// =============================================================================

/**
 * Status eines laufenden Minispiels
 */
const MINIGAME_STATUS = {
  PENDING: 'pending',           // Warte auf Start
  SPLASH: 'splash',             // Splash-Screen wird angezeigt
  PLAYING: 'playing',           // Minispiel läuft
  WAITING_RESULTS: 'waitingResults', // Warte auf Ergebnis-ACK
  COMPLETED: 'completed',       // Abgeschlossen
  TIMEOUT: 'timeout',           // Timeout erreicht
};

// =============================================================================
// PLAYER STATUS IM MINIGAME
// =============================================================================

/**
 * Status eines Spielers im Minispiel
 */
const PLAYER_MINIGAME_STATUS = {
  WAITING: 'waiting',           // Wartet auf Start
  PLAYING: 'playing',           // Spielt aktiv
  COMPLETED: 'completed',       // Hat abgeschlossen
  DISCONNECTED: 'disconnected', // Verbindung verloren
};

// =============================================================================
// REWARD TYPES
// =============================================================================

/**
 * Arten von Belohnungen
 */
const REWARD_TYPE = {
  POINTS: 'points',
  COINS: 'coins',
  MULT: 'mult',
  CARD: 'card',                 // Zufällige Karte vom Stapel
  JOKER: 'joker',               // Zufälliger Joker
  SEAL: 'seal',                 // Zufälliges Siegel
};

// =============================================================================
// SOCKET EVENTS
// =============================================================================

/**
 * Socket-Events für Minispiel-Kommunikation
 */
const MINIGAME_EVENTS = {
  // Server → Client
  START: 'minigameStart',
  STATE_UPDATE: 'minigameStateUpdate',
  RESULT: 'minigameResult',
  RESUME: 'minigameResume',
  TURN_START: 'minigameTurnStart',  // Sequential: nächster Spieler ist dran

  // Client → Server
  SPLASH_COMPLETE: 'minigameSplashComplete',
  PLAYER_ACTION: 'minigamePlayerAction',
  PLAYER_COMPLETE: 'minigamePlayerComplete',
  ACKNOWLEDGE: 'minigameAcknowledge',
};

// =============================================================================
// EXPORTS
// =============================================================================

module.exports = {
  MINIGAME_MODE,
  SYNC_TYPE,
  MINIGAME_TRIGGER,
  MINIGAME_STATUS,
  PLAYER_MINIGAME_STATUS,
  REWARD_TYPE,
  MINIGAME_EVENTS,
};
